import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sectionList: [],
  sectionDetail: [],
  loading: false,
  error: undefined,
};

const sectionSlice = createSlice({
  name: "section",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchSectionList(state, action) {
      state.sectionList = action.payload;
      state.loading = false;
    },
    fetchSectionDetail(state, action) {
      state.sectionDetail = action.payload;
      state.loading = false;
    },
  },
});

export const sectionActions = sectionSlice.actions;

export default sectionSlice.reducer;
